import gql from 'graphql-tag'

export const STATUS_BY_VEHICLE = gql`
  query($id: ID!) {
    trackable_status(id: $id) {
      id
      metadata 
      latitude
      longitude
      reverse_geocoding {
        display_name
      }
    }
  }
`

export const STATUS_BY_VEHICLE_UPDATED = gql`
  subscription($id: ID!) {
    trackable_status_update(id: $id) {
      id
      metadata
      latitude
      longitude
      reverse_geocoding {
        display_name
      }
    }
  }
`

export const ODOMETER_BY_VEHICLE = gql`
  query($id: ID!) {
    trackable_status(id: $id) {
      id
      metadata
    }
  }
`
export const ODOMETER_BY_VEHICLE_UPDATED = gql`
  subscription($id: ID!) {
    trackable_status_update(id: $id) {
      id
      metadata
    }
  }
`

export const GET_TRACKABLES_BY_FLEET = gql`
  query($fleetId: String!) {
    fleet(label: $fleetId) {
      name
      trackables{
        id
        label
        name
      }
    }
  }
`

export const GET_VEHICLE_NUMBER_BY_ID = gql`
  query($trackableId: ID) {
    trackable(id: $trackableId){
      licensePlate
    }
  }
`
